import { useParams, useSearchParams } from 'next/navigation'
import { useMemo } from 'react'

export default function useSearch() {
  const { params } = useParams<{ params?: string[] }>()
  const searchParams = useSearchParams()
  const mainCategorySearchParam: string | undefined = searchParams.get('main_category') ?? undefined

  // Resolve the query and main category
  const [query, mainCategory] = useMemo(() => {
    let encodedQuery: string
    let mainCategory: string | undefined

    // If the main category is provided in the search params, use it
    if (mainCategorySearchParam) {
      encodedQuery = params?.[0] ?? ''
      mainCategory = mainCategorySearchParam
    } else {
      encodedQuery = params?.[1] ?? ''
      mainCategory = params?.[0] ?? undefined
    }

    return [decodeURIComponent(encodedQuery), mainCategory === 'all' ? undefined : mainCategory]
  }, [mainCategorySearchParam, params])

  return {
    query,
    mainCategorySlug: mainCategory,
  }
}
